/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 受付共通情報
 */
export interface Sgkb575aResAceptCommonInfo {
    /** 
     * 受付番号：半角数字
     */
    aceptNo?: string;
    /** 
     * 受付履歴番号：半角数字
     */
    aceptRrkno?: string;
    /** 
     * 更新通番号：半角数字
     */
    updateSrno?: string;
    /** 
     * 更新区分：半角英数混在
     */
    updateDiv?: string;
    /** 
     * 更新区分名称：全角半角混在
     */
    updateDivAname?: string;
    /** 
     * 内部お客さま番号：半角数字
     */
    visitNo?: string;
    /** 
     * 使用お客さま番号：半角数字
     */
    logicDeviceNo?: string;
    /** 
     * 契約お客さま番号：半角数字
     */
    firstSrvctrNo?: string;
    /** 
     * 請求お客さま番号：半角数字
     */
    recptFixNo?: string;
    /** 
     * 送付先複写区分：半角英数混在
     */
    sendtoCopyDiv?: string;
    /** 
     * 送付先複写区分名称：全角半角混在
     */
    sendtoCopyDivAname?: string;
    /** 
     * 同時受付番号：半角数字
     */
    simltnAceptNo?: string;
    /** 
     * 受付種別コード：半角英数混在
     */
    aceptClsfy?: string;
    /** 
     * 受付種別コード名称：全角半角混在
     */
    aceptClsfyAname?: string;
    /** 
     * 受付日付：日付YYYYMMDD
     */
    aceptDate?: string;
    /** 
     * 受付時刻：時間HHMM
     */
    aceptHms?: string;
    /** 
     * 受付担当組織番号：半角英数混在
     */
    aceptSosikiCode?: string;
    /** 
     * 受付担当社員番号：半角英数混在
     */
    aceptStaffNo?: string;
    /** 
     * 受付ステータス：半角英数混在
     */
    aceptSts?: string;
    /** 
     * 受付ステータス名称：全角半角混在
     */
    aceptStsAname?: string;
    /** 
     * お客さま承諾フラグ：半角英数混在
     */
    cstFlg?: string;
    /** 
     * お客さま承諾フラグ名称：全角半角混在
     */
    cstFlgAname?: string;
    /** 
     * 開通受付番号：半角数字
     */
    provAceptNo?: string;
    /** 
     * 開通受付履歴番号：半角数字
     */
    provAceptRrkno?: string;
    /** 
     * 変更先内部お客さま番号：半角数字
     */
    chgtoVisitNo?: string;
    /** 
     * 外部接続番号：半角英数混在
     */
    extCnnctNo?: string;
    /** 
     * 取消有無コード：半角英数混在
     */
    cancelFlg?: string;
    /** 
     * 取消有無コード名称：全角半角混在
     */
    cancelCodeAname?: string;
    /** 
     * 登録日付：日付YYYYMMDD
     */
    regDate?: string;
    /** 
     * 登録時刻：時間HHMM
     */
    registrationtime?: string;
    /** 
     * 登録者組織番号：半角英数混在
     */
    creatorSosikiNo?: string;
    /** 
     * 登録者社員番号：半角英数混在
     */
    creatorStaffNo?: string;
    /** 
     * 承認日付：日付YYYYMMDD
     */
    apprvDate?: string;
    /** 
     * 承認時刻：時間HHMM
     */
    apprvHms?: string;
    /** 
     * 承認者組織番号：半角英数混在
     */
    approverstaffnumberSskno?: string;
    /** 
     * 承認者者社員番号：半角英数混在
     */
    approverstaffnumberStafno?: string;
    /** 
     * 要料金訂正フラグ：半角英数混在
     */
    feerequiredTeiseiFlg?: string;
    /** 
     * 要料金訂正フラグ名称：全角半角混在
     */
    yoChrgtseiFlganame?: string;
    /** 
     * 会社グループコード：半角英数混在
     */
    companygroupcode?: string;
    /** 
     * 会社グループコード名称：全角半角混在
     */
    companygroupcodeAname?: string;
    /** 
     * 会社コード：半角英数混在
     */
    companycode?: string;
    /** 
     * 会社コード名称：全角半角混在
     */
    companycodeAname?: string;
    /** 
     * 地区コード：半角英数混在
     */
    areacode?: string;
    /** 
     * 地区コード名称：全角半角混在
     */
    areacodeAname?: string;
    /** 
     * 登録ステータス：半角英数混在
     */
    registrationstatus?: string;
    /** 
     * 登録ステータス名称：全角半角混在
     */
    registrationstatusAname?: string;
    /** 
     * 合算請求先受付番号：半角数字
     */
    sumaddClmtoAcceptancenumber?: string;
    /** 
     * 同一地点キー：半角英数混在
     */
    sameLocationkey?: string;
    /** 
     * 契約開始受付番号：半角数字
     */
    ctrstrAcceptancenumber?: string;
    /** 
     * エネルギー種別コード：半角英数混在
     */
    energyClscode?: string;
    /** 
     * エネルギー種別コード名称：全角半角混在
     */
    energyClsfyCodeaname?: string;
    /** 
     * 契約獲得者：全角半角混在
     */
    contractacquirer?: string;
}
